import {
  get
} from "lodash";
import {
  getStatisticsBank,
  getStatisticsCardPurchases,
  getStatisticsCardSales,
  getStatisticsCashReceipts,
  getStatisticsInvoice,
  getStatisticsSalaryHistory,
  getStatisticsTaxInvoice
} from "../apis/finances/statistics";
import {
  getDay
} from "./date";

export const getFinancesStatistics = async ({
  startAt = getDay(6),
  endAt = getDay(),
  dateRange,
  groupBy = 'date',
  ...params
}) => {
  return new Promise((resolve, reject) => {
    const invoice = getStatisticsInvoice({
      ...params,
      groupBy,
      range: {
        writeDate: {
          from: startAt,
          to: endAt
        }
      }
    })
    const taxInvoice = getStatisticsTaxInvoice({
      ...params,
      groupBy,
      range: {
        writeDate: {
          from: startAt,
          to: endAt
        }
      }
    })
    const cardPurchases = getStatisticsCardPurchases({
      ...params,
      groupBy,
      range: {
        date: {
          from: startAt,
          to: endAt
        }
      }
    })
    const cardSales = getStatisticsCardSales({
      ...params,
      groupBy,
      range: {
        payDate: {
          from: startAt,
          to: endAt
        }
      }
    })
    const cashReceipts = getStatisticsCashReceipts({
      ...params,
      groupBy,
      range: {
        date: {
          from: startAt,
          to: endAt
        }
      }
    })
    const bank = getStatisticsBank({
      ...params,
      groupBy,
      range: {
        date: {
          from: startAt,
          to: endAt
        }
      }
    })

    const salaryHistory = getStatisticsSalaryHistory({
      ...params,
      groupBy,
      range: {
        date: {
          from: startAt,
          to: endAt
        }
      }
    })
    Promise.all([taxInvoice, cardPurchases, cardSales, cashReceipts, bank, salaryHistory, invoice])
      .then(([_taxInvoice, _cardPurchases, _cardSales, _cashReceipts, _bank, _salaryHistory, _invoice]) => {


        const taxPurchase = get(_taxInvoice, 'data.data', []).filter(data => data.supByrType === 'purchase')
        const taxSales = get(_taxInvoice, 'data.data', []).filter(data => data.supByrType === "sales")
        const cardPurchase = get(_cardPurchases, 'data.data.purchaseList', [])
        const cardSales = get(_cardSales, 'data.data', [])

        const cashReceiptsPurchase = get(_cashReceipts, 'data.data', []).filter(data => data.type === "purchase")
        const cashReceiptsSales = get(_cashReceipts, 'data.data', []).filter(data => data.type === "sales")

        const banks = get(_bank, 'data.data', [])
        const salaryHistories = get(_salaryHistory, 'data.data', [])


        /*
        const invoiceSales = get(_invoice, 'data.data', []).filter(data => data.totalAmt > 0) // data.supByrType === 'sales'
        const invoicePurchase = get(_invoice, 'data.data', []).filter(data => data.totalAmt < 0) // data.supByrType === 'purchase'
        */
        const invoiceSales = get(_invoice, 'data.data', []).filter(data => data.supByrType === 'sales') // data.supByrType === 'sales'
        const invoicePurchase = get(_invoice, 'data.data', []).filter(data => data.supByrType === 'purchase') // data.supByrType === 'purchase'

        // console.log('financesStatistics : ', {
        //   taxPurchase,
        //   taxSales,
        //   cardPurchase,
        //   cardSales,
        //   cashReceiptsPurchase,
        //   cashReceiptsSales,
        //   banks,
        //   salaryHistories
        // })
        resolve({
          taxPurchase,
          taxSales,
          cardPurchase,
          cardSales,
          cashReceiptsPurchase,
          cashReceiptsSales,
          banks,
          salaryHistories,
          invoiceSales,
          invoicePurchase
        })
      })
  })
}